'use strict';

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const UserInfo=require('../../../dist-es6/client/dtos/userInfo');let

UserService=class UserService extends BaseService{
constructor($state,cookieRefresherService,$window,socketService,displaySettingsService,groupBasedDataHelperService,Analytics,errorHandlers,fatigueMeterTypeContentProviderService){
super();
this._$state=$state;
this._cookieRefresherService=cookieRefresherService;
this._$window=$window;
this._socketService=socketService;
this._displaySettingsService=displaySettingsService;
this._groupBasedDataHelperService=groupBasedDataHelperService;
this._analytics=Analytics;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

this._currentUser=void 0;
errorHandlers.getCurrentUser=()=>this._currentUser;
}

async logout(){
try{
let socketResponse=await this._socketService.sendAndWaitForResponse('EndUserSession');

if(SocketResponse.succeeded(socketResponse)&&_.exists(socketResponse,'body.redirect')){
this._$window.location=socketResponse.body.redirect;
return;
}
}catch(e){

}finally{
if(_.exists(this._currentUser)){
this._analytics.trackEvent('session','logout',this._currentUser.email);
}
}


this._bounceToLogin();
}

_processResponse(userDataSocketResponse,trackingLabel){
if(!SocketResponse.succeeded(userDataSocketResponse)){
return;
}

const{userInfo,displaySettings}=userDataSocketResponse.body;

this._currentUser=UserInfo.fromJSON(userInfo);

if(_.exists(displaySettings)){
this._displaySettingsService.incorporateLatestSettingsFromBackend(displaySettings);
}

const fatigueMeterType=_.get(this._currentUser,'fatigueMeterType');
this._groupBasedDataHelperService.updateFatigueMeterType(fatigueMeterType);
this._fatigueMeterTypeContentProviderService.updateProvidedContentToType(fatigueMeterType);

this._analytics.trackEvent('session',trackingLabel,this._currentUser.email);
}

_bounceToLogin(){




this._$state.go('fdc.features.login',{});
this.clearAllUserData();

}

clearAllUserData(){
this._currentUser=void 0;
this._groupBasedDataHelperService.resetAllData();
}

async beginUserSession(loginRequest){
if(this._onLoginScreen){
this.clearAllUserData();
}

await this._cookieRefresherService.refreshCookieImmediate();
await this._socketService.reconnect();
const userDataSocketResponse=await this._socketService.sendAndWaitForResponse('BeginUserSession',loginRequest,{keepSessionAlive:!1});
await this._cookieRefresherService.refreshCookieImmediate();
this._processResponse(userDataSocketResponse,'login');

return userDataSocketResponse;
}

async continueUserSession(){
const userDataSocketResponse=await this._socketService.sendAndWaitForResponse('ContinueUserSession');

this._processResponse(userDataSocketResponse,'continue');

if(!SocketResponse.succeeded(userDataSocketResponse)){
this._bounceToLogin();
}

return userDataSocketResponse;
}

get currentUser(){
return this._currentUser;
}

async updateCurrentUserInfo(userData){
let userDataSocketResponse=await this._socketService.sendAndWaitForResponse('UpdateCurrentUserInfo',userData);
if(SocketResponse.succeeded(userDataSocketResponse)){
this._processResponse(userDataSocketResponse,'changeUserInfo');
}
return userDataSocketResponse;
}

async changePassword(passwordRequest){
return await this._socketService.sendAndWaitForResponse('ResetCurrentUserPassword',passwordRequest);
}

get _onLoginScreen(){
return this._$state.current.name==='fdc.features.login';
}};


module.exports=UserService;
//# sourceMappingURL=userService.js.map
